export const parseJwtPayload = (token) => {
  try {
    const part = String(token || '').split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
};

export const getTokenRole = () => {
  try {
    const token = localStorage.getItem('glovy_token');
    if (!token) return '';
    const payload = parseJwtPayload(token);
    return String(payload?.role || '').toUpperCase();
  } catch {
    return '';
  }
};

export const getStoredUserRole = () => {
  try {
    const saved = JSON.parse(localStorage.getItem('glovy_user') || 'null');
    return String(saved?.role || '').toUpperCase();
  } catch {
    return '';
  }
};

export const getEffectiveRole = (user) =>
  String(user?.role || getStoredUserRole() || getTokenRole() || '').toUpperCase();

export const isAdminRole = (user) => {
  const role = getEffectiveRole(user);
  return role === 'ADMIN' || role === 'ROLE_ADMIN';
};
